import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CollapseBlock, Spinner } from '../../../../../common';
import { routes } from '../../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../../basic';
import {
  useGetAttendanceEventsQuery,
  useGetAttendanceEventByTeacherQuery,
  useDeleteAttendanceEventMutation,
  useGetAttendanceTeacherSubjectsEventsQuery,
} from '../../../../../../redux/services/attendance';
import AttendanceEventsTable from './AttendanceEventsTable.jsx';
import { useToastMessages } from '../../../../../../hooks/useToastMessages';

const AttendanceEventsPage = ({ all = true }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const shouldFetchAllEvents = all === true;
  const shouldFetchMyEvents = all === false;

  const {
    data: attendanceAllEvents,
    isLoading: isLoadingAllEvents,
    refetch: refetchAllEvents,
  } = shouldFetchAllEvents
    ? useGetAttendanceEventsQuery()
    : { data: undefined, isLoading: false };

  const { data: attendanceMyEvents, isLoading: isLoadingMyEvents } =
    shouldFetchMyEvents
      ? useGetAttendanceEventByTeacherQuery()
      : { data: undefined, isLoading: false };

  const { data: subjects, isLoading: isLoadingSubjects } =
    useGetAttendanceTeacherSubjectsEventsQuery({
      events: 'true',
      all: shouldFetchAllEvents,
    });

  const [deleteAttendanceEvent, { isSuccess: isDeleteSuccess }] =
    useDeleteAttendanceEventMutation();
  const { deleteSuccess: toastDeleteSuccess } = useToastMessages();

  useEffect(() => {
    if (isDeleteSuccess) {
      toastDeleteSuccess();
      if (shouldFetchAllEvents) {
        refetchAllEvents();
      }
    }
  }, [isDeleteSuccess]);

  return isLoadingAllEvents || isLoadingMyEvents || isLoadingSubjects ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Udalosti')}
        backUrl={routes.cmsAttendanceSchedule}
        backUrlTooltip={t('Rozvrh')}
        permissionsBasic={'attendace-events.schedule'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <AttendanceEventsTable
            attendanceEvents={
              shouldFetchAllEvents ? attendanceAllEvents : attendanceMyEvents
            }
            onDetailClick={(record) =>
              navigate(`${routes.cmsAttendanceEventDetail}/${record.id}`)
            }
            subjects={subjects}
            onDelete={
              shouldFetchAllEvents
                ? (record) => deleteAttendanceEvent(record.id)
                : null
            }
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default AttendanceEventsPage;
